export const clearSearch = (data) => {
  const information = ['fundInformation', 'copyPortInformation', 'modelPortInformation', 'articleInformation'];
  return Object.keys(data).reduce((object, key) => {
    const check = information.includes(key);
    if (check) {
      object[key] = [];
    } else {
      object[key] = data[key];
    }
    return object;
  }, {});
};

export const cleanSearch = (data) => {
  const information = ['fundInformation', 'copyPortInformation', 'modelPortInformation', 'articleInformation'];
  return Object.keys(data).reduce((object, key) => {
    const check = information.includes(key);
    if (check && data[key] != null) {
      object[key] = data[key];
    } else if (check && data[key] == null) {
      object[key] = [];
    } else {
      object[key] = data[key];
    }
    return object;
  }, {});
};

export const setIsFetching = (state) => {
  return {
    ...state,
    isFetching: true
  }
};

export const resetSearchResults = (state, data) => {
  return {
    ...state,
    isFetching: false,
    searchList: clearSearch(data)
  }
};

export const resetSearchText = (state) => {
  return {
    ...state,
    searchText: null
  }
};

export const filterSearchResults = (state, data) => {
  return {
    ...state,
    isFetching: false,
    searchList: cleanSearch(data)
  }
};

export const clearSearchResults = (state) => {
  return {
    ...state,
    searchList: clearSearch(state.searchList)
  }
};

export const updateSearchText = (state, data) => {
  return {
    ...state,
    searchText: data
  }
};
